import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import axios from "axios";
import Logo from "../assets/images/logo-white.svg";
import { updateUsername, updatePassword, onLoggedin } from "../actions";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LogoiCON from "../../src/assets/images/logo.png";
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoad: true,
      isSubmitting: false, // New state for loader during form submission
      errorMessage: ""
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        isLoad: false
      });
    }, 500);
    document.body.classList.remove("theme-cyan");
    document.body.classList.remove("theme-purple");
    document.body.classList.remove("theme-blue");
    document.body.classList.remove("theme-green");
    document.body.classList.remove("theme-orange");
    document.body.classList.remove("theme-blush");
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    const { username, password } = this.props;

    this.setState({ isSubmitting: true }); // Show loader when API call starts

    try {
      const response = await axios.post("https://samaj.aasmo.in/api/admin/login", { username, password });
      const token = response.data.token;

      // Save the token in local or session storage
      localStorage.setItem("authToken", token);

      // Show success toast
      toast.success("Login successful!");

      // Update the state or perform other actions
      this.props.onLoggedin(token); // Update this according to your logic

      // Redirect after a delay
      setTimeout(() => {
        this.props.history.push("/dashboard"); // Redirect to the admin page
      }, 3000); // 3000ms = 3 seconds
    } catch (error) {
      const errorMsg = error.response?.data?.message || "An error occurred. Please try again.";
      this.setState({ errorMessage: errorMsg });

      // Show error toast
      toast.error(errorMsg);
    } finally {
      this.setState({ isSubmitting: false }); // Hide loader when API call finishes
    }
  };

  render() {
    return (
      <div className="theme-cyan">
        <ToastContainer />
        <div className="page-loader-wrapper" style={{ display: this.state.isLoad || this.state.isSubmitting ? 'block' : 'none' }}>
          <div className="loader">
          <div className="m-t-30">
              <img src={LogoiCON} width="48" height="48" alt="MarwadiSamaj" />
            </div>
            <p>Please wait...</p>
          </div>
        </div>
        <div className="hide-border">
          <div className="vertical-align-wrap">
            <div className="vertical-align-middle auth-main">
              <div className="auth-box">
                <div className="card">
                  <div className="header">
                    <p className="lead">Login to your account</p>
                  </div>
                  <div className="body">
                    <form className="form-auth-small" onSubmit={this.handleSubmit}>
                      <div className="form-group">
                        <label className="control-label sr-only">Username</label>
                        <input
                          className="form-control"
                          id="signin-username"
                          placeholder="Username"
                          type="text"
                          value={this.props.username}
                          onChange={val => this.props.updateUsername(val.target.value)}
                        />
                      </div>
                      <div className="form-group">
                        <label className="control-label sr-only">Password</label>
                        <input
                          className="form-control"
                          id="signin-password"
                          placeholder="Password"
                          type="password"
                          value={this.props.password}
                          onChange={val => this.props.updatePassword(val.target.value)}
                        />
                      </div>
                      <div className="form-group clearfix">
                        <label className="fancy-checkbox element-left">
                          <input type="checkbox" />
                          <span>Remember me</span>
                        </label>
                      </div>
                      <button
                        className="btn btn-primary btn-lg btn-block"
                        type="submit"
                        disabled={this.state.isSubmitting} // Disable button while submitting
                      >
                        {this.state.isSubmitting ? "Logging in..." : "Login"}
                      </button>
                      <div className="bottom">
                        <span className="helper-text m-b-10">
                          <i className="fa fa-lock"></i>{" "}
                          <a href={`${process.env.PUBLIC_URL}/forgotpassword`}>Forgot password?</a>
                        </span>
                        <span>
                          Don't have an account?{" "}
                          <a href="registration">Register</a>
                        </span>
                      </div>
                      {this.state.errorMessage && (
                        <div className="alert alert-danger" role="alert">
                          {this.state.errorMessage}
                        </div>
                      )}
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Login.propTypes = {
  updateUsername: PropTypes.func.isRequired,
  updatePassword: PropTypes.func.isRequired,
  onLoggedin: PropTypes.func.isRequired,
  username: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired
};

const mapStateToProps = ({ loginReducer }) => ({
  username: loginReducer.username,
  password: loginReducer.password
});

export default connect(mapStateToProps, {
  updateUsername,
  updatePassword,
  onLoggedin
})(Login);
